



























































































































































import Vue from 'vue'
import PieChart from '@/components/dashboard/PieChart.vue'
import ColumnChart from '@/components/dashboard/ColumnChart.vue'
import DashboardTable from '@/components/dashboard/DashboardTable.vue'
import GanttChart from '@/components/dashboard/GanttChart.vue'
import Messages from '@/components/dashboard/Messages.vue'
import HolidayBalanceChart from '@/components/dashboard/HolidayBalanceChart.vue'
import { FETCH_DASHBOARD_DATA } from '@/store/action-types'
import moment from 'moment'
import _ from 'lodash'
import { GET_SELECTED_UI_LANGUAGE } from '@/store/getter-types'
import { DashboardData } from '@/model/dashboard/DashboardData'
import { GanttChartData } from '@/model/dashboard/GanttChartData'
import { DashboardMessage } from '@/model/dashboard/DashboardMessage'
import { DailyTableData } from '@/model/dashboard/DailyTableData'
import { PieChartData } from '@/model/dashboard/PieChartData'
import { ColumnChartData } from '@/model/dashboard/ColumnChartData'
import { DashboardGanttEmployeeList } from '@/types'
import ColumnInverseChart from '@/components/dashboard/ColumnInverseChart.vue'
import GanttChartScheduleWeek from '@/components/dashboard/GanttChartScheduleWeek.vue'
import LineChartB2BB2C from '@/components/dashboard/LineChartB2BB2C.vue'
import LineChartPHB2BB2C from '@/components/dashboard/LineChartPHB2BB2C.vue'
import PieChartB2BB2C from '@/components/dashboard/PieChartB2BB2C.vue'
import PieChartPHB2BB2C from '@/components/dashboard/PieChartPHB2BB2C.vue'
import LineChartNewInactiveClients from '@/components/dashboard/LineChartNewInactiveClients.vue'
import PieChartTP from '@/components/dashboard/PieChartTP.vue'
import PieChartTAP from '@/components/dashboard/PieChartTAP.vue'

interface ComponentData {
  componentTypeMap: Map<string, string>
  data: Array<DashboardData>
  employees: DashboardGanttEmployeeList
  ganttLabel: string
  ganttChartData: Array<GanttChartData>
  ganttDate: string
  columnChartLabel: string
  columnChartData: Array<ColumnChartData>
  columnChartDate: string
  columnInverseChartLabel: string
  columnInverseChartData: Array<ColumnChartData>
  columnInverseChartDate: string
  pieChartLabel: string
  pieChartData: Array<PieChartData>
  messagesLabel: string
  messagesData: Array<DashboardMessage>
  isMessagesData: boolean
  dashboardTableLabel: string
  dashboardTableHeaders: Array<any>
  dashboardTableData: Array<DailyTableData>
  dashboardTableDate: string
  ganttLabelScheduleWeek: string
  ganttChartScheduleWeekData: Array<GanttChartData>
  ganttDateScheduleWeek: string
  chartB2BB2CLabel: string
  chartB2BB2CDate: string
  chartB2BB2CData: any[]
  chartPHB2BB2CLabel: string
  chartPHB2BB2CDate: string
  chartPHB2BB2CData: any[]
  pieChartB2BB2CLabel: string
  pieChartB2BB2CDate: string
  pieChartB2BB2CData: any[]
  pieChartPHB2BB2CLabel: string
  pieChartPHB2BB2CDate: string
  pieChartPHB2BB2CData: any[]
  chartNewInactiveClientsLabel: string
  chartNewInactiveClientsDate: string
  chartNewInactiveClientsCData: any[]
  pieChartTPLabel: string
  pieChartTPDate: string
  pieChartTPData: any[]
  pieChartTAPLabel: string
  pieChartTAPDate: string
  pieChartTAPData: any[]
}

export default Vue.extend({
  name: 'DashboardPage',

  components: {
    PieChart,
    ColumnChart,
    DashboardTable,
    GanttChart,
    Messages,
    HolidayBalanceChart,
    ColumnInverseChart,
    GanttChartScheduleWeek,
    LineChartB2BB2C,
    LineChartPHB2BB2C,
    PieChartB2BB2C,
    PieChartPHB2BB2C,
    LineChartNewInactiveClients,
    PieChartTP,
    PieChartTAP
  },

  data (): ComponentData {
    return {
      componentTypeMap: new Map([
        ['w_schedule_daily', 'GanttChart'], ['w_capacity_by_employee', 'ColumnChart'],
        ['w_capacity_percentage', 'PieChart'], ['w_messages', 'Messages'], ['w_schedule_daily_table', 'DashboardTable'],
        ['w_bvg_by_employee', 'ColumnInverseChart'], ['w_schedule_week', 'GanttChartScheduleWeek'], ['w_turnover_b2b_b2c', 'LineChartB2BB2C'],
        ['w_plannedhours_b2b_b2c', 'LineChartPHB2BB2C'], ['w_turnover_b2b_b2c_percentage', 'PieChartB2BB2C'], ['w_plannedhours_b2b_b2c_percentage', 'PieChartPHB2BB2C'],
        ['w_new_inactive_clients', 'LineChartNewInactiveClients'], ['w_turnover_products', 'PieChartTP'], ['w_turnover_additionalproducts', 'PieChartTAP']
      ]),
      data: [],
      employees: [],
      ganttLabel: '',
      ganttChartData: [],
      ganttDate: '',
      columnChartLabel: '',
      columnChartData: [],
      columnChartDate: '',
      columnInverseChartLabel: '',
      columnInverseChartData: [],
      columnInverseChartDate: '',
      pieChartLabel: '',
      pieChartData: [],
      messagesLabel: '',
      messagesData: [],
      isMessagesData: false,
      dashboardTableLabel: '',
      dashboardTableHeaders: [
        { text: this.$t('dashboard.employee').toString(), align: 'left', value: 'employee' },
        { text: this.$t('dashboard.time').toString(), align: 'left', value: 'time' },
        { text: this.$t('dashboard.entry').toString(), align: 'left', value: 'entry' },
        { text: this.$t('dashboard.conflict').toString(), align: 'left', value: 'conflict' }
      ],
      dashboardTableData: [],
      dashboardTableDate: '',
      ganttLabelScheduleWeek: '',
      ganttChartScheduleWeekData: [],
      ganttDateScheduleWeek: '',
      chartB2BB2CLabel: '',
      chartB2BB2CDate: '',
      chartB2BB2CData: [],
      chartPHB2BB2CLabel: '',
      chartPHB2BB2CDate: '',
      chartPHB2BB2CData: [],
      pieChartB2BB2CLabel: '',
      pieChartB2BB2CDate: '',
      pieChartB2BB2CData: [],
      pieChartPHB2BB2CLabel: '',
      pieChartPHB2BB2CDate: '',
      pieChartPHB2BB2CData: [],
      chartNewInactiveClientsLabel: '',
      chartNewInactiveClientsDate: '',
      chartNewInactiveClientsCData: [],
      pieChartTPLabel: '',
      pieChartTPDate: '',
      pieChartTPData: [],
      pieChartTAPLabel: '',
      pieChartTAPDate: '',
      pieChartTAPData: [],
    }
  },

  computed: {
    dashboardItemListFirstRow (): Array<DashboardData> | undefined {
      if (this.data && this.ganttChartData) {
        return _.sortBy(this.data.filter((item: DashboardData) => item.rowPosition === 1), ['columnPosition'])
      } else {
        return undefined
      }
    },

    dashboardItemListSecondRow (): Array<DashboardData> | undefined {
      if (this.data && this.columnChartData) {
        return _.sortBy(this.data.filter((item: DashboardData) => item.rowPosition === 2), ['columnPosition'])
      } else {
        return undefined
      }
    },

    dashboardItemListThirdRow (): Array<DashboardData> | undefined {
      if (this.data && this.columnChartData) {
        return _.sortBy(this.data.filter((item: DashboardData) => item.rowPosition === 3), ['columnPosition'])
      } else {
        return undefined
      }
    },

    selectedLanguage (): string {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].code
    }
  },

  methods: {
    componentClass (item: string): string | undefined {
      if (this.componentTypeMap.get(item) === 'GanttChart') {
        return 'gantt'
      } else if (this.componentTypeMap.get(item) === 'ColumnChart') {
        return 'capacityChart'
      } else if (this.componentTypeMap.get(item) === 'PieChart' || this.componentTypeMap.get(item) === 'PieChartB2BB2C' || this.componentTypeMap.get(item) === 'PieChartPHB2BB2C') {
        return 'pieChart'
      } else if (this.componentTypeMap.get(item) === 'Messages') {
        return 'messages'
      } else if (this.componentTypeMap.get(item) === 'DashboardTable') {
        return 'table'
      } else if (this.componentTypeMap.get(item) === 'ColumnInverseChart') {
        return 'columnInverseChart'
      } else if (this.componentTypeMap.get(item) === 'GanttChartScheduleWeek') {
        return 'ganttWeek'
      } else if (this.componentTypeMap.get(item) === 'LineChartB2BB2C' || this.componentTypeMap.get(item) === 'LineChartPHB2BB2C') {
        return 'b2bb2c'
      }  else if (this.componentTypeMap.get(item) === 'LineChartNewInactiveClients') {
        return 'newInactiveClients'
      } else if (this.componentTypeMap.get(item) === 'PieChartTP' || this.componentTypeMap.get(item) === 'PieChartTAP') {
        return 'pieChartRightLegend'
      } else {
        return undefined
      }
    },

    createGanttChartData (data: DashboardData): void {
      if (data && data.widgetName && data.widgetData) {
        this.ganttLabel = data.widgetName
        this.ganttDate = `${this.$t('dashboard.updated')}: ${moment(data.lastUpdatedDate).format('DD.MM.YYYY HH:mm')}`
        this.ganttChartData = data.widgetData
        const filteredData: any = _.uniqBy(data.widgetData, 'name')
        this.employees = filteredData.map((item: GanttChartData) => {
          return { name: item.name }
        })
      }
    },

    createGanttChartScheduleWeekData (data: DashboardData): void {
      if (data && data.widgetName && data.widgetData) {
        this.ganttLabelScheduleWeek = data.widgetName
        this.ganttDateScheduleWeek = `${this.$t('dashboard.updated')}: ${moment(data.lastUpdatedDate).format('DD.MM.YYYY HH:mm')}`
        this.ganttChartScheduleWeekData = data.widgetData
        const filteredData: any = _.uniqBy(data.widgetData, 'name')
        this.employees = filteredData.map((item: GanttChartData) => {
          return { name: item.name }
        })
      }
    },

    createMessagesTable (data: DashboardData): void {
      if (data && data.widgetName && data.widgetData) {
        this.messagesLabel = data.widgetName
        this.isMessagesData = true
        if (data.widgetData) {
          this.messagesData = data.widgetData
        }
      } else {
        this.messagesLabel = data.widgetName
        this.isMessagesData = false
      }
    },

    createDashboardTable (data: DashboardData): void {
      if (data && data.widgetName && data.widgetData) {
        this.dashboardTableLabel = data.widgetName
        this.dashboardTableDate = `${this.$t('dashboard.updated')}: ${moment(data.lastUpdatedDate).format('DD.MM.YYYY HH:mm')}`
        this.dashboardTableData = data.widgetData
      }
    },

    createPieChart (data: DashboardData): void {
      if (data && data.widgetName && data.widgetData) {
        const month: string = moment(data.lastUpdatedDate).locale(this.selectedLanguage).format('MMMM')
        this.pieChartLabel = `${data.widgetName} - ${month}`
        this.pieChartData = data.widgetData
      }
    },

    createColumnChart (data: DashboardData): void {
      if (data && data.widgetName && data.widgetData) {
        const month: string = moment(data.lastUpdatedDate).locale(this.selectedLanguage).format('MMMM')
        this.columnChartLabel = `${data.widgetName} - ${month}`
        this.columnChartDate = `${this.$t('dashboard.updated')}: ${moment(data.lastUpdatedDate).format('DD.MM.YYYY HH:mm')}`
        this.columnChartData = data.widgetData
      }
    },

    createColumnInverseChart (data: DashboardData): void {
      if (data && data.widgetName && data.widgetData) {
        const month: string = moment(data.lastUpdatedDate).locale(this.selectedLanguage).format('MMMM')
        this.columnInverseChartLabel = `${data.widgetName} - ${month}`
        this.columnInverseChartDate = `${this.$t('dashboard.updated')}: ${moment(data.lastUpdatedDate).format('DD.MM.YYYY HH:mm')}`
        this.columnInverseChartData = data.widgetData
      }
    },

    createB2BB2CChartData (data: DashboardData): void {
      if (data && data.widgetName && data.widgetData) {
        this.chartB2BB2CLabel = data.widgetName
        this.chartB2BB2CDate = `${this.$t('dashboard.updated')}: ${moment(data.lastUpdatedDate).format('DD.MM.YYYY HH:mm')}`
        this.chartB2BB2CData = data.widgetData
      }
    },

    createPHB2BB2CChartData (data: DashboardData): void {
      if (data && data.widgetName && data.widgetData) {
        this.chartPHB2BB2CLabel = data.widgetName
        this.chartPHB2BB2CDate = `${this.$t('dashboard.updated')}: ${moment(data.lastUpdatedDate).format('DD.MM.YYYY HH:mm')}`
        this.chartPHB2BB2CData = data.widgetData
      }
    },

    createPieChartB2BB2CCData (data: DashboardData): void {
      if (data && data.widgetName && data.widgetData) {
        this.pieChartB2BB2CLabel = data.widgetName
        this.pieChartB2BB2CDate = `${this.$t('dashboard.updated')}: ${moment(data.lastUpdatedDate).format('DD.MM.YYYY HH:mm')}`
        this.pieChartB2BB2CData = data.widgetData
      }
    },

    createPieChartPHB2BB2CData (data: DashboardData): void {
      if (data && data.widgetName && data.widgetData) {
        this.pieChartPHB2BB2CLabel = data.widgetName
        this.pieChartPHB2BB2CDate = `${this.$t('dashboard.updated')}: ${moment(data.lastUpdatedDate).format('DD.MM.YYYY HH:mm')}`
        this.pieChartPHB2BB2CData = data.widgetData
      }
    },

    createNewInactiveClientsData (data: DashboardData): void {
      if (data && data.widgetName && data.widgetData) {
        this.chartNewInactiveClientsLabel = data.widgetName
        this.chartNewInactiveClientsDate = `${this.$t('dashboard.updated')}: ${moment(data.lastUpdatedDate).format('DD.MM.YYYY HH:mm')}`
        this.chartNewInactiveClientsCData = data.widgetData
      }
    },

    createPieChartTPData (data: DashboardData): void {
      if (data && data.widgetName && data.widgetData) {
        this.pieChartTPLabel = data.widgetName
        this.pieChartTPDate = `${this.$t('dashboard.updated')}: ${moment(data.lastUpdatedDate).format('DD.MM.YYYY HH:mm')}`
        this.pieChartTPData = data.widgetData
      }
    },

    createPieChartTAPData (data: DashboardData): void {
      if (data && data.widgetName && data.widgetData) {
        this.pieChartTAPLabel = data.widgetName
        this.pieChartTAPDate = `${this.$t('dashboard.updated')}: ${moment(data.lastUpdatedDate).format('DD.MM.YYYY HH:mm')}`
        this.pieChartTAPData = data.widgetData
      }
    },

    async fetchDashboardData (): Promise<void> {
      this.data = await this.$store.dispatch(FETCH_DASHBOARD_DATA)

      if(this.data.length === 1) {
        document.documentElement.style.setProperty('--chart-height', '100%')
      } else {
        document.documentElement.style.setProperty('--chart-height', '40vh')
      }

      this.data.forEach((item: DashboardData) => {
        if (item.code === 'w_schedule_daily') {
          this.createGanttChartData(item)
        } else if (item.code === 'w_messages') {
          this.createMessagesTable(item)
        } else if (item.code === 'w_schedule_daily_table') {
          this.createDashboardTable(item)
        } else if (item.code === 'w_capacity_percentage') {
          this.createPieChart(item)
        } else if (item.code === 'w_capacity_by_employee') {
          this.createColumnChart(item)
        } else if (item.code === 'w_bvg_by_employee') {
          this.createColumnInverseChart(item)
        } else if (item.code === 'w_schedule_week') {
          this.createGanttChartScheduleWeekData(item)
        } else if (item.code === 'w_turnover_b2b_b2c') {
          this.createB2BB2CChartData(item)
        } else if (item.code === 'w_plannedhours_b2b_b2c') {
          this.createPHB2BB2CChartData(item)
        } else if (item.code === 'w_turnover_b2b_b2c_percentage') {
          this.createPieChartB2BB2CCData(item)
        } else if (item.code === 'w_plannedhours_b2b_b2c_percentage') {
          this.createPieChartPHB2BB2CData(item)
        } else if (item.code === 'w_new_inactive_clients') {
          this.createNewInactiveClientsData(item)
        } else if (item.code === 'w_turnover_products') {
          this.createPieChartTPData(item)
        } else if (item.code === 'w_turnover_additionalproducts') {
          this.createPieChartTAPData(item)
        }
      })
    },

    onDashboardSettingsButtonClick () {
      this.$router.push('dashboard-settings')
    }
  },

  created () {
    this.fetchDashboardData()
  }

})
